import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page when:
 * 1. Route changes (pathname changes)
 * 2. Query parameters change (search changes)
 * 3. Hash fragments change (hash changes)
 * 4. Component mounts (initial page load)
 * 
 * This ensures users always start at the beginning of each page,
 * providing a consistent navigation experience.
 * 
 * For state changes within pages that should trigger scroll-to-top,
 * use the useScrollToTop hook in individual components.
 */
const ScrollToTop = () => {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    // Scroll to top when pathname, search params, or hash changes
    // This handles route changes, query parameter changes, and hash changes
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant' // Use instant for immediate scroll without animation
    });
  }, [pathname, search, hash]);

  // Also scroll to top when the component mounts (initial page load)
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant'
    });
  }, []);

  return null;
};

export default ScrollToTop;
